export const IMAGE_PRODUCT_DISABLED = 'https://fintecimal-common.s3.amazonaws.com/chiplo/product_disabled.svg';
